import { ListingProduct, Product } from '@/network/graphql.g'
import { ID } from 'graphql-ws'

export interface BridgeProduct extends Product {
  preload?: boolean
  colorVariantsIds?: ID[]
}

export const convertAPIProductToProduct = (
  product: ListingProduct
): BridgeProduct => ({
  ...product,
  __typename: 'Product',
  mainCategory: {
    id: product.mainCategoryId
  },
  allImages: [product.mainImage],
  colorVariantsIds: product?.colorVariantsIds ?? []
})

export const convertAPIProductToProductRecommender = (
  product: Product
): BridgeProduct => ({
  ...product,
  __typename: 'Product',
  mainCategory: {
    id: product.mainCategory.id
  },
  allImages: [product.mainImage]
})
